import { ReactNode } from 'react';

import { ReactComponent as SortIcon } from 'assets/icons/ArrowsDownUp.svg';
import { TableHeaderOptions } from 'types/components/table.types';
import { LoadingSkeleton } from 'shared/index';

import styles from './TableHead.module.scss';

type Props<T extends NonNullable<object>> = {
  headerOptions: TableHeaderOptions<T>[];
  TableActionElement?: ReactNode;
  onSort?: (key: keyof T) => void;
  isLoading?: boolean;
  testId?: string;
};

export const TableHead = <T extends NonNullable<object>>({
  headerOptions,
  TableActionElement,
  onSort,
  isLoading = false,
  testId = 'table-head',
}: Props<T>) => (
  <thead data-testid={testId}>
    <tr data-testid={`${testId}-row`}>
      {headerOptions.map(({ isSortable, key, label }, index) => (
        <th key={index + label} data-testid={`${testId}-cell-${label}`.toLowerCase()}>
          {isLoading ? (
            <LoadingSkeleton className={styles.loadingCell} />
          ) : (
            <div className={styles.headerCell}>
              {isSortable && <SortIcon onClick={() => onSort?.(key)} />}
              <span>{label}</span>
            </div>
          )}
        </th>
      ))}
      {!!TableActionElement && (
        <th data-testid={`${testId}-action-cell`}>
          {isLoading ? <LoadingSkeleton className={styles.loadingCell} /> : TableActionElement}
        </th>
      )}
    </tr>
  </thead>
);
